import type { AnnotationStyle } from "@virdx/wsi-viewer"

const DEFAULT_FILL_TO_STROKE_RATIO = 0.2

export function clampOpacity01(value: number): number {
  if (!Number.isFinite(value)) return 0
  if (value <= 0) return 0
  if (value >= 1) return 1
  return value
}

export function getEffectiveOpacity(style: AnnotationStyle): number {
  return clampOpacity01(Math.max(style.strokeOpacity, style.fillOpacity))
}

function resolveFillToStrokeRatio(style: AnnotationStyle): number {
  if (style.strokeOpacity > 0) {
    return Math.max(style.fillOpacity / style.strokeOpacity, 0)
  }
  if (style.fillOpacity > 0) {
    return 1
  }
  return DEFAULT_FILL_TO_STROKE_RATIO
}

export function applyOpacityToStyle(
  style: AnnotationStyle,
  nextOpacity: number
): Pick<AnnotationStyle, "strokeOpacity" | "fillOpacity"> {
  const strokeOpacity = clampOpacity01(nextOpacity)
  const fillToStrokeRatio = resolveFillToStrokeRatio(style)
  const fillOpacity = clampOpacity01(strokeOpacity * fillToStrokeRatio)

  return { strokeOpacity, fillOpacity }
}

export function restoreVisibleOpacity(lastVisibleOpacity: number | undefined): number {
  return clampOpacity01(lastVisibleOpacity ?? 1)
}
